import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {ModuleState, PageState} from './kontakte.reducer';


export const getModuleState = createFeatureSelector<ModuleState>('KontaktverwaltungPage');
export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getFunktionsbereicheKontakteListe = createSelector(getPageState, (state: PageState) => {
    if (state.funktionsbereicheKontakteListe === null || state.funktionsbereicheKontakteListe === undefined) {
        return [];
    } else {
        const res: Array<ListInputItem> = [];
        state.funktionsbereicheKontakteListe.forEach((fb) => {
            if (fb.kontakte.length > 0) {
                fb.kontakte.forEach(k => {
                    res.push(<ListInputItem>{
                        groupId: fb.funktionsbereich.funktionsbereich_id,
                        groupTitle: fb.funktionsbereich.titel,
                        group: fb.funktionsbereich,
                        groupClass: 'funktionsbereiche',
                        itemId: k.kontakt_id,
                        itemTitle: k.vorname + ' ' + k.name,
                        item: {
                            kontakt: k,
                            funktionsbereich: fb.funktionsbereich
                        }
                    });
                });
            } else {
                res.push(<ListInputItem>{
                    groupId: fb.funktionsbereich.funktionsbereich_id,
                    groupTitle: fb.funktionsbereich.titel,
                    group: fb.funktionsbereich,
                    groupClass: 'funktionsbereiche',
                    itemId: null,
                    itemTitle: null,
                    item: null
                });
            }
        });
        return res;
    }
});
export const getFunktionsbereicheKontakteListeLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereicheKontakteListeLaden);
export const getFunktionsbereicheKontakteListeFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereicheKontakteListeFehler);

export const getAktuellerFunktionsbereich = createSelector(getPageState, (state: PageState) => state.aktuellerFunktionsbereich);

export const getAktuellerKontakt = createSelector(getPageState, (state: PageState) => state.aktuellerKontakt);

export const getKontaktDetail = createSelector(getPageState, (state: PageState) => state.kontaktDetail);
export const getKontaktDetailLaden = createSelector(getPageState, (state: PageState) => state.kontaktDetailLaden);
export const getKontaktDetailFehler = createSelector(getPageState, (state: PageState) => state.kontaktDetailFehler);

export const getKontaktTelefonnummern = createSelector(getPageState, (state: PageState) => {
    if (state.kontaktTelefone === null || state.kontaktTelefone === undefined) {
        return [];
    } else {
        const res: Array<ListInputItem> = [];
        state.kontaktTelefone.forEach((kt) => {
            res.push(<ListInputItem>{
                groupId: null,
                groupTitle: null,
                group: null,
                groupClass: null,
                itemId: kt.kontakt_telefon_id,
                itemTitle: kt.label,
                item: kt
            });
        });
        return res;
    }
});
export const getKontaktTelefonnummernLaden = createSelector(getPageState, (state: PageState) => state.kontaktTelefoneLaden);
export const getKontaktTelefonnummernFehler = createSelector(getPageState, (state: PageState) => state.kontaktTelefoneFehler);

export const getAktuelleTelefonnummer = createSelector(getPageState, (state: PageState) => state.aktuelleTelefonnummer);
